export function handleAdminQuantityDefinitionCategoryCreated(state, payload) {
    const { category } = payload;
    // console.log('so new category is: ', category)

    if (!category?.id) return state;

    if (state.categoriesById[category.id]) return state;

    const newCategory = {
        ...category,

        nodeId: `c${category.id}`,

        parents: [],
        direct: [],
        type: 'category',
        orderNumber: category.order_number ?? 9999,
        isActive: category.is_active ?? true,
    };

    const nextState = {
        ...state,
        categoriesById: {
        ...state.categoriesById,
        [category.id]: newCategory,
        },
        categoryIds: [
            ...state.categoryIds,
            category.id,
        ],
    };

    console.log('state.categoriesById: ', state.categoriesById)
    // 👇 DEBUG: inspect full result BEFORE returning
    console.log("🔥 NEXT STATE:", nextState);

    console.log("📦 categoriesById keys:", Object.keys(nextState.categoriesById));

    console.log("🆕 inserted category:", nextState.categoriesById[category.id]);

    return nextState;

}